var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news"},[_c('pageCart',{attrs:{"title":"Nyheder"}},[_c('div',{staticClass:"items"},_vm._l((_vm.items),function(item){return _c('item',_vm._b({key:item.id},'item',item,false))}))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }